/**
 * characterItemContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for character items with gradient background and hover border effect.
 */
const CharacterItemContainer = styled.div<{
  backgroundColor: string;
  $focused?: boolean;
  hide?: boolean;
}>`
  border-radius: ${26 * Screen.widthRatio}px;
  border: ${4 * Screen.widthRatio}px solid
    ${(props) => (props.$focused ? 'white' : 'transparent')};
  cursor: pointer;
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  float: left;
  height: ${200 * Screen.widthRatio}px;
  justify-content: center;
  margin-right: ${16 * Screen.widthRatio}px;
  pointer-events: all;
  margin-top: ${4 * Screen.widthRatio}px;
  width: ${200 * Screen.widthRatio}px;
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default withOpacity(CharacterItemContainer);
